"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import { RxChevronRight } from "react-icons/rx";
import ContactButton from "../../components/shared/ContactButton";

export function Insights() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28 bg-[#02172A] text-white">
      <div className="container  md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="grid grid-cols-1 items-start gap-5 md:grid-cols-2 md:gap-x-12 lg:gap-x-20">
          <div>
            <p className="mb-3 font-semibold md:mb-4 font-bold">Insights</p>
            <h3 className="mb-3 font-bold text-xl md:mb-4 font-bold">Warum Sie handeln sollten</h3>
            <h2 className="rb-5 mb-5 text-2xl md:mb-6 md:text-3xl lg:text-5xl lg:leading-15">
            Die heutige Landschaft der Cyber-Bedrohungen verstehen
            </h2> 
          </div>
          <div>
            <p className="mb-6 md:mb-8 md:text-md">
            Cyber-Bedrohungen entwickeln sich in einem noch nie dagewesenen Tempo weiter. Bleiben Sie informiert, um Ihr Unternehmen wirksam zu schützen.
            </p>
            <div className="grid grid-cols-1 gap-6 py-2 sm:grid-cols-2">
              <div>
                <h3 className="mb-2 text-5xl md:text-7xl lg:text-5xl">
                81 % 
                </h3>
                <p>der deutschen Unternehmen waren in vergangenen zwölf Monaten von Cyber-Diebstahl betroffen.</p>
              </div>
              <div>
                <h3 className="mb-2 text-5xl  md:text-7xl lg:text-5xl">
                266,6 Mrd
                </h3>
                <p>Schäden durch Cyber-Diebstahl, Spionage und Sabotage in deutschen Unternehmen im Jahr 2024</p>
              </div>
            </div>
            <div className="mt-6 flex flex-wrap items-center gap-4 md:mt-8">
            
            <ContactButton/>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
